var React = require('react');

function Error (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Error 404"},[React.createElement("path",{"d":"M59 2H5a3 3 0 0 0-3 3v54a3 3 0 0 0 3 3h54a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3zM5 4h54a1 1 0 0 1 1 1v5H4V5a1 1 0 0 1 1-1zm54 56H5a1 1 0 0 1-1-1V12h56v47a1 1 0 0 1-1 1z","key":0}),React.createElement("path",{"d":"M7 8h1a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2zM12 8h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2zM17 8h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2zM32 25a6.006 6.006 0 0 0-6 6v10a6 6 0 0 0 12 0V31a6.006 6.006 0 0 0-6-6zm4 16a4 4 0 0 1-8 0V31a4 4 0 0 1 8 0zM55 39h-3V26a1 1 0 0 0-2 0v13h-5a1 1 0 0 1-1-1V26a1 1 0 0 0-2 0v12a3 3 0 0 0 3 3h5v5a1 1 0 0 0 2 0v-5h3a1 1 0 0 0 0-2zM23 39h-3V26a1 1 0 0 0-2 0v13h-5a1 1 0 0 1-1-1V26a1 1 0 0 0-2 0v12a3 3 0 0 0 3 3h5v5a1 1 0 0 0 2 0v-5h3a1 1 0 0 0 0-2z","key":1})]));
}

Error.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = Error;

Error.default = Error;
